import { render } from "./BottomModal.vue?vue&type=template&id=23a6e016&scoped=true"
import script from "./BottomModal.vue?vue&type=script&lang=js"
export * from "./BottomModal.vue?vue&type=script&lang=js"

import "./BottomModal.vue?vue&type=style&index=0&id=23a6e016&scoped=true&lang=css"

import exportComponent from "/home/dr/PhpstormProjects/anh/vue/scheduleweek/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23a6e016"]])

export default __exports__